const FEED_TYPES = ['breastmilk', 'formula', 'nursing'];

export function resolveGestureSelection(kind, x, y, width, height, phase) {
  if (![x, y, width, height].every(Number.isFinite) || x < 0 || y < 0 || x > width || y > height) return null;
  if (y < 112) return 'cancel';
  if (kind === 'feed') {
    // Keep the legacy two-zone mapping when no phase is supplied for callers
    // that still use the old desktop helper directly.
    if (phase === undefined) {
      if (x > width * 0.67) return null;
      return y < height * 0.53 ? 'breastmilk' : 'formula';
    }
    if (phase === 'side') {
      if (x < width / 3) return 'left';
      if (x > width * 2 / 3) return 'right';
      return null;
    }
    if (x < width / 3) return FEED_TYPES[0];
    if (x < width * 2 / 3) return FEED_TYPES[1];
    return FEED_TYPES[2];
  }
  const levels = kind === 'poop' ? 5 : 3;
  const edge = 16;
  if (x < edge || x > width - edge) return null;
  return Math.min(levels - 1, Math.max(0, Math.floor(((x - edge) / (width - edge * 2)) * levels))) + 1;
}

export function feedAmountForHold(milliseconds, settings = {}) {
  const safeDuration = Math.max(0, Number(milliseconds) || 0);
  const step = Number.isInteger(Number(settings.step)) && Number(settings.step) > 0 ? Number(settings.step) : 5;
  const interval = Number.isInteger(Number(settings.intervalMs)) && Number(settings.intervalMs) >= 100 ? Number(settings.intervalMs) : 100;
  const initial = Number.isInteger(Number(settings.initial)) && Number(settings.initial) > 0 ? Number(settings.initial) : 20;
  const max = Number.isInteger(Number(settings.max)) && Number(settings.max) >= initial ? Number(settings.max) : Math.max(300, initial);
  return Math.min(max, initial + Math.floor(safeDuration / interval) * step);
}

export function nursingAmountForHold(milliseconds, settings = {}) {
  const safeDuration = Math.max(0, Number(milliseconds) || 0);
  const step = Number.isInteger(Number(settings.nursingStep)) && Number(settings.nursingStep) > 0
    ? Number(settings.nursingStep)
    : 1;
  const interval = Number.isInteger(Number(settings.intervalMs)) && Number(settings.intervalMs) >= 100 ? Number(settings.intervalMs) : 1000;
  const initial = Number.isInteger(Number(settings.initial)) && Number(settings.initial) > 0 ? Number(settings.initial) : 1;
  const max = Number.isInteger(Number(settings.max)) && Number(settings.max) >= initial ? Number(settings.max) : Math.max(180, initial);
  return Math.min(max, initial + Math.floor(safeDuration / interval) * step);
}

export function formatElapsed(milliseconds) {
  const totalSeconds = Math.max(0, Math.floor((Number(milliseconds) || 0) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const minuteLabel = String(minutes).padStart(2, '0');
  const secondLabel = String(seconds).padStart(2, '0');
  return hours > 0 ? `${hours}:${minuteLabel}:${secondLabel}` : `${minuteLabel}:${secondLabel}`;
}
